import { Component, ElementRef, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { HostListener, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConstantsService } from '@app/common/constants.service';
import { AgGridConfigurationService } from '@app/shared/services/ag-grid-configuration.service';
import { AlertService } from '@app/shared/services/alert.service';
import { LoaderService } from '@app/shared/services/loader.service';
import { ReleaseMgmtService } from '@app/shared/services/releaseMgmtService';
import { ColDef, GridOptions, IColumnToolPanel, RowModelType } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { TableLazyLoadEvent } from 'primeng/table';
import { MenuContextualService } from '@app/shared/services/menu-contextual.service';
import { RoleService } from '@app/shared/services/role.service';
import { AddViewReleaseListService } from '@app/shared/services/add-view-release-list.service';
import { PermissionDefinitionDto } from '@app/apiModules/permissionDefinitionDto';
import { PermissionService } from '@app/shared/services/PermissionService';
import { environment } from '../../../../environments/environment';
import { IdentityRoleDto } from '@app/apiModules/roleDtoPagedResultDto';
import { CommonModule, DOCUMENT } from '@angular/common';
import { AddRoleComponent } from '@app/modules/administrator/roles-management-main/add-role/add-role.component';
import { SliderComponent } from '@app/shared/shared-components/slider/slider.component';
import { AgGridModule } from 'ag-grid-angular';
import { AgGridSelectAllComponent } from '@app/shared/shared-components/ag-grid-select-all/ag-grid-select-all.component';
import { UserAuthService } from '@app/shared/services/user-auth.service';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    standalone: true,
    selector: 'app-roles-management-main',
    templateUrl: './roles-management-main.component.html',
    styleUrl: './roles-management-main.component.scss',
    imports: [AddRoleComponent, SliderComponent, AgGridModule, CommonModule, MatIconModule, MatTooltipModule]
})
export class RolesManagementMainComponent implements OnInit {
  @Output() public roleSliderData: IdentityRoleDto;
  roleSliderId = 'addEditRoleSlider';
  sliderHeader = 'Role Management';
  sliderDescription = 'Manage roles efficiently';
  headerToolTip = 'Manage roles efficiently';
  tenantName = 'DemoTenant';  // Static Tenant Name
  totalRecords = 10;  // Mock count of total roles
  paginationPageSize = 30;
  infiniteInitialRowCount = 30;
  sideBar = true;
  editmode = false;
  defaultPermissions: PermissionDefinitionDto[] = [];

  casePlaceholder = 'Select Role Features';  // Placeholder text
  releaseId = 0;
  isEnvironmentSelected = false;
  databaseRollbackList = [];
  filteredEnvironments = [];
  allEnvironments = [];
  searchFilterControlEnvironments: UntypedFormControl = new UntypedFormControl();
  selectedEnvironmentId = '';
  SelectEnvInfoMsg = 'Select environment to deploy the Release';
  testWidth = 250;
  gridOptions: GridOptions;
  columnDefs: any;
  agGridColDef: any;
  pageSize = 30;
  selectedRow: any = {};
  pageSizeList: number[] = [25, 50, 75, 100];
  api: any;
  public gridColumnApi: any;
  agGridRowData: any;
  public overlayNoRowsTemplate = '<span style="font-weight: 400; color: #757575; ">No records found</span>';
  cacheBlockSize: any = 30;
  maxBlocksInCache: any = 30;
  blockLoadDebounceMillis = 100;
  rowModelType: RowModelType = 'serverSide';
  // rowHeight = 38;
  styleChipDiv = 'width:100%; height: calc(100vh - 280px); flex: 1 1 auto; border: 1px solid #DFDFDF;';
  serverSideStoreType = 'partial';
  loading: boolean;

  public defaultColDef: ColDef =  {
    //flex: 1,
    minWidth: 150,
    maxWidth: 400,
    sortable: true,
    resizable: true,
    filter: true,
    floatingFilter: true,
    enableRowGroup: true,
    enableValue: true,
    headerCheckboxSelection: false, // set to true for checkbox selection
    checkboxSelection: false, // set to true for checkbox selection
   // rowSelection: 'multiple', // set to 'single' or 'multiple' for checkbox selection
   // suppressRowClickSelection: true // if true, clicking rows doesn't select (useful for checkbox selection)
  };
  gridDataParams: any;
  selectedReleaseLegoRollbackStatusId: any;
  rowData: any[];
  dataSource: any;
  roles: any;
  isCurrentUserAdmin: any;
  isMenuShow: boolean;
  releaseList: any;
  components: any = {
      agGridSelectAllComponent: AgGridSelectAllComponent
    };
  gridOptions1: { rowModelType: string; serverSideStoreType: string; onBodyScroll: any; onCellClicked: any; getServerSideStoreParams: (params: any) => { cacheBlockSize: number; maxBlocksInCache: number; }; };
  constructor(public readonly agGridConfigurationService: AgGridConfigurationService,
    public releaseMgmtService: ReleaseMgmtService,
    public roleService: RoleService,
    public contextMenu: MenuContextualService, private permissionService: PermissionService,
    public constantsService: ConstantsService, // Service for accessing application constants
    public route: ActivatedRoute, public viewContainerRef: ViewContainerRef,
    public readonly alertService: AlertService, // Service for managing alerts
    public loader: LoaderService, private readonly addViewReleaseListService: AddViewReleaseListService,
    public toastr: ToastrService,
    public readonly userAuthService: UserAuthService
  ) {
  }

  @HostListener('window:resize', ['$event'])
  ngOnInit() {
    this.setAgGridCol();
    this.getdefaultPermissions();
  }
  /**
   * Refreshes the data in the ag-Grid by setting the server-side datasource.
   */
  /* istanbul ignore next */
  refreshData() {
    // `datasource` is set to the result of the `getGridData` method with null as the argument
    const datasource = this.getRoleGridData(null);
    // The server-side datasource for the ag-Grid is set to `datasource`
    this.api?.setServerSideDatasource(datasource);
  }

  getdefaultPermissions() {
    this.permissionService.apiAppdefaultPermissionsGet(null)
      .subscribe({
        next: (response) => {
          this.defaultPermissions = response;
        },
        error: (_error) => {
          //Intentional
        }
      });
  }
  setAgGridCol() {
    this.agGridColDef =
    {
      tableName: 'tableName',
      column:
        [
          { columnName: 'name', headerName: 'Role Name', dataType: 'string', columnType: 'string', cellStyle: 'left', sortable: true, floatingFilter: true, width: 40, minWidth: this.columnWidth('gridRoles', 24), maxWidth: this.columnWidth('gridRoles', 54) },
          { columnName: 'description', headerName: 'Description', dataType: 'string', columnType: 'string', cellStyle: 'left', sortable: true, floatingFilter: true, width: 40, minWidth: this.columnWidth('gridRoles', 34), maxWidth: this.columnWidth('gridRoles', 70) },
          {
            columnName: 'isActive', headerName: 'Status', dataType: 'string', columnType: 'string', cellStyle: 'left', width: 40, minWidth: this.columnWidth('gridRoles', 25), maxWidth: this.columnWidth('gridRoles', 54),
            field: 'isActive',
            filter: 'agSetColumnFilter'
          },
          { columnName: 'ACTION', headerName: 'Action', dataType: 'string', columnType: 'string', filter: false, cellStyle: 'center', width: 40, minWidth: this.columnWidth('gridRoles', 17), maxWidth: this.columnWidth('gridRoles', 23) }
        ]
    };
    this.rowModelType = 'serverSide';
    this.gridOptions = {
      onBodyScroll: this.handleScroll.bind(this),
      onCellClicked: this.handleCellClick.bind(this)
    };
    this.columnDefs = this.agGridConfigurationService.GetRoleManagementColmnDefs(this.agGridColDef);
    this.defaultColDef = {
      filter: true,
      floatingFilter: true
    }
  }
  columnWidth(id, percentage) {
    const div = document.getElementById(id);  // HTML ID of Grid
      const parent = div.parentElement;
      const width = parent.clientWidth * percentage / 100;  // Pixel calculation
      return width;
  }
  onSidebarToggle() {
    setTimeout(() => {
      document.getElementById(this.roleSliderId).style.width = '100%';
    }, 200);
  }
  handleScroll(event) {
    if (this.isMenuShow) {
      this.isMenuShow = false;
    }
  }
  handleCellClick(event) {
    if (event.column.colId === 'ACTION') {
      this.isMenuShow = true;
    }
  }
  onRolesGridReady = (params) => {
     if (!this.api) {
      params.startRow = 0;
      params.endRow = this.pageSize;
      this.gridDataParams = params;
      this.api = params.api;
      this.gridColumnApi = params.api;
      const columnToolPanel = (this.api.getToolPanelInstance('columns') as any) as IColumnToolPanel; //NOSONAR
      columnToolPanel.setPivotModeSectionVisible(false);
      columnToolPanel.setRowGroupsSectionVisible(false);
      columnToolPanel.setValuesSectionVisible(false);
      columnToolPanel.setPivotSectionVisible(false);
      const datasource = this.getRoleGridData(null);
      this.api?.setServerSideDatasource(datasource);
      this.api?.closeToolPanel();
      this.api?.setSideBar(false);
      
      this.onResize();

    }
  };
  getRoleGridData(event: TableLazyLoadEvent) {
    return {
      getRows: (params) => {
        this.api.setColumnDefs(this.columnDefs);

        if (params.request.filterModel['isActive'] && params.request.filterModel['isActive'].values) {
          const value = params.request.filterModel['isActive'].values;
          params.request.filterModel['isactive'] = {
            'filterType': 'text',
            'type': 'contains',
            'filter': value.join(',')
          };
        }

        this.setLoader();
        this.roleService.apiAppRoleRolesPost(params.request).subscribe({
          next: (res) => {
            if (res && res.items.length > 0) {
              this.agGridRowData = res.items;
              this.totalRecords = res.totalCount;
              params.success({
                rowData: this.agGridRowData,
                rowCount: res.totalCount,
              });
              this.api.hideOverlay();
            } else {
              params.success({ rowData: [], rowCount: 0 });
              this.api.showNoRowsOverlay();
            }
          },
          error: (err) => {
            this.toastr.error('Error while fetching data', 'Error');
            this.api.showNoRowsOverlay();
          },
          complete: () => {
            this.setUnLoader();
          }
        });
      }
    };
  }

  onResize() {
    if (!this.api) {
      setTimeout(() => {
        this.api?.refreshCells();
        this.api?.sizeColumnsToFit();
      }, 500);
      return;
    }
  }

  showErrorMessageByCode(messageCode) {
    let errorMessage = 'Error while initiating rollback';

    if (messageCode === 'NO_ENVIRONMENT_MAPPING_FOUND') {
      errorMessage = this.constantsService.NO_ENVIRONMENT_MAPPING_FOUND;
    } else if (messageCode === 'NO_RELEASE_SERVICE_MAPPING_FOUND') {
      errorMessage = this.constantsService.NO_RELEASE_SERVICE_MAPPING_FOUND;
    } else if (messageCode === 'NO_RELEASE_FOUND') {
      errorMessage = this.constantsService.NO_RELEASE_FOUND;
    } else if (messageCode === 'ROLLBACK_JOB_ALREADY_IN_PROGRESS') {
      errorMessage = this.constantsService.ROLLBACK_JOB_ALREADY_IN_PROGRESS;
    } else if (messageCode === 'SPECIFIED_ROLLBACK_VERSION_NOT_FOUND') {
      errorMessage = this.constantsService.SPECIFIED_ROLLBACK_VERSION_NOT_FOUND;
    } else if (messageCode === 'ROLLBACK_FILE_NOT_FOUND') {
      errorMessage = this.constantsService.ROLLBACK_FILE_NOT_FOUND;
    } else if (messageCode === 'MISSING_URL_PATH') {
      errorMessage = this.constantsService.Missing_Url_Path;
    } else if (messageCode === 'MISSING_CLIENTKEY_OR_APIKEY') {
      errorMessage = this.constantsService.Missing_ClientKey_Or_ApiKey;
    } else if (messageCode === 'INVALID_TOKEN') {
      errorMessage = this.constantsService.InvalidToken;
    }

    this.toastr.error(errorMessage, 'Error');
  }
  setPageSize() {
    this.api.paginationSetPageSize(this.pageSize);
  }
  setLoader() {
    this.loading = true;
    this.loader.showSpinner.next(true);
  }
  setUnLoader() {
    this.loading = false;
    this.loader.showSpinner.next(false);
  }
  tableMenuClick(event, obj, _origin, _menuTemplate) {
    if (event.column.colId === 'ACTION') {
      obj.allowModify = true;
      const contextObj = {
        extraProperties: obj,
        id: obj.id,
        title: obj.name,
        imgTitle: null,
        image: null,
        subTitle: obj.description,
        statusText: obj.updatedOn,
        subStatusText: '   ',
        concurrencyStamp: null,
        status: obj.status,
        tenantid: obj.tenantId,
        allowModify: obj.allowModify
      };
      
      this.contextMenu.open(event.event, this.viewContainerRef, contextObj, origin, _menuTemplate);
    }
  }
  updateRole(role): void {
    this.roleSliderData = role;
    this.editmode = true;
    setTimeout(() => {
      document.getElementById(this.roleSliderId).style.width = this.constantsService.sliderWidth;
    }, 1800);
  }

  addRole(): void {

    this.editmode = false;
    setTimeout(() => {
      document.getElementById(this.roleSliderId).style.width = this.constantsService.sliderWidth;
    }, 1800);
  }
  // delete dialog
  deleteDialog(role) {
    this.alertService.buildDialog().fire({
      title: 'Are you sure?',
      text: 'You want to remove the role?',
      icon: this.alertService.WarningIcon,
      showCancelButton: true,
      confirmButtonText: 'Yes, Remove!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.roleService.apiAppRoleIdDelete(role.id).subscribe({
          next: () => {
            let toastMsg = '';
            toastMsg = 'Role removed successfully';
            this.toastr.success(toastMsg, '');

            this.ngOnInit();
            this.refreshData();
          },
          error: (error) => {
            // if error code is 602 then show the error message
            if (error.error.error.code === '602') {
              this.alertService.buildDialog().fire({
                title: 'You cannot remove this role!',
                text: 'The role is assigned to a user!',
                icon: this.alertService.ErrorIcon,
                showCancelButton: false,
                confirmButtonText: 'Ok',
                cancelButtonText: '',
              });
            }
            // if error code is 604 then show the error message
            else if (error.error.error.code === '604') {
              this.alertService.buildDialog().fire({
                title: 'Role not found!',
                text: 'Role not found!',
                icon: this.alertService.ErrorIcon,
                showCancelButton: false,
                confirmButtonText: 'Ok',
                cancelButtonText: '',
              });
            }
            else {
              this.alertService.buildDialog().fire({
                title: 'You cannot remove this Role!',
                text:  error.error.error.message,
                icon: this.alertService.ErrorIcon,
                showCancelButton: false,
                confirmButtonText: 'Ok',
                cancelButtonText: '',
              });
            }
            this.ngOnInit();
            this.refreshData();
          }
        });
      }
    })
  }


  // set role status
  setRoleStatus(role, status) {
    let confrimMessage = '';
    let toastMsg = '';
    let buttonText = '';
    // if status is true then set the message
    if (status) {
      confrimMessage = 'You want to set active for ' + role.name;
      toastMsg = 'Role activated successfully';
      buttonText = 'Yes, Set Active!'
    }
    else {
      confrimMessage = 'You want to set inactive for ' + role.name;
      toastMsg = 'Role inactivated successfully';
      buttonText = 'Yes, Set Inactive!'
    }
    this.alertService.buildDialog().fire({
      title: 'Are you sure?',
      text: confrimMessage,
      icon: this.alertService.WarningIcon,
      showCancelButton: true,
      confirmButtonText: buttonText,
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.roleService.apiAppRoleIdSetActiveInactivePost(role.id, status)
          .subscribe({
            next: () => {
              this.toastr.success(toastMsg, '');
              this.ngOnInit();
              this.refreshData();
            },
            error: (error) => {
              if (error.error.error.code === '602') {
                this.alertService.buildDialog().fire({
                 title: 'You can\'t inactive this role!',
                 text: 'This role is assigned to user(s)',
                  icon: this.alertService.WarningIcon,
                  showCancelButton: false,
                  confirmButtonText: 'OK',
                  cancelButtonText: '',
                });
              } else {
                this.alertService.buildDialog().fire({
                  title: 'You can\'t inactive this role!',
                  text: error.error.error.message,
                  icon: this.alertService.ErrorIcon,
                  showCancelButton: false,
                  confirmButtonText: 'OK',
                  cancelButtonText: '',
                });
              }

              this.ngOnInit();
              this.refreshData();
            }
          });
      }
    });
  }

  closeNav() {
    this.editmode = !this.editmode;
    this.refreshData();
    document.getElementById(this.roleSliderId).style.width = this.constantsService.sliderResetWidth;
  }

  noop() { } // no-operation empty event 
}
